import classnames from "classnames";
import {
    UncontrolledAlert,
    Button,
    Card,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
} from "reactstrap";
import AuthHeader from "components/Headers/AuthHeader.js";
import { resetPassword } from 'api/authApiCall';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from '../i18n/context';

const PasswordReset = () => {
    const { t } = useTranslation();
    const [focusedEmail, setFocusedEmail] = React.useState(false);
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [focusedPassword, setFocusedPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // 
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            setError(t('common.match'));
            return;
        }

        try {
            await resetPassword(token, newPassword);
            setMessage(t('common.reset_success'));
            setTimeout(() => {
                navigate('/auth/login');
            }, 2000);
            setError('');
        } catch (error) {
            setMessage('');
            setError('common.reset_fail');
        }
    };

    return (
        <>
            <AuthHeader
                title={t('common.reset')}
            />
            <Container className="mt--8 pb-5">
                <Row className="justify-content-center">
                    <Col lg="5" md="7">
                        <Card className="bg-secondary border-0 mb-0">
                            <CardBody className="px-lg-5 py-lg-5">
                                <div className="text-center text-muted mb-4">
                                    <small>{t('common.enter')}</small>
                                </div>
                                <Form role="form" onSubmit={handleSubmit}>
                                    <FormGroup
                                        className={classnames({
                                            focused: focusedPassword,
                                        })}
                                    >
                                        <InputGroup className="input-group-merge input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-lock-circle-open" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                type={showNewPassword ? "text" : "password"}
                                                placeholder="New password"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                                required
                                                onFocus={() => setFocusedPassword(true)}
                                                onBlur={() => setFocusedPassword(false)}
                                            />
                                            <InputGroupAddon addonType="append">
                                                <InputGroupText
                                                    onClick={() => setShowNewPassword(!showNewPassword)} // Toggle new password visibility
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </FormGroup>
                                    <FormGroup
                                        className={classnames({
                                            focused: focusedPassword,
                                        })}
                                    >
                                        <InputGroup className="input-group-merge input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-lock-circle-open" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                type={showConfirmPassword ? "text" : "password"} // Toggle input type based on state
                                                placeholder="Confirm password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                required
                                                onFocus={() => setFocusedPassword(true)}
                                                onBlur={() => setFocusedPassword(false)}
                                            />
                                            <InputGroupAddon addonType="append">
                                                <InputGroupText
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)} // Toggle confirm password visibility
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </FormGroup>

                                    <div className="text-center">
                                        <Button className="my-4" color="info" type="submit">
                                        {t('common.reset')}
                                        </Button>
                                    </div>
                                </Form>
                                {message && (
                                    <UncontrolledAlert color="primary">
                                        <span className="alert-text ml-1">
                                            <strong>{message}</strong>
                                        </span>
                                    </UncontrolledAlert>
                                )}
                                {error && (
                                    <UncontrolledAlert color="danger">
                                        <span className="alert-text ml-1">
                                            <strong>{error}</strong>
                                        </span>
                                    </UncontrolledAlert>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default PasswordReset;
